import { render, staticRenderFns } from "./MultiTextAnswerDisplay.vue?vue&type=template&id=a32478f0&scoped=true"
import script from "./MultiTextAnswerDisplay.vue?vue&type=script&lang=ts"
export * from "./MultiTextAnswerDisplay.vue?vue&type=script&lang=ts"
import style0 from "./MultiTextAnswerDisplay.vue?vue&type=style&index=0&id=a32478f0&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32478f0",
  null
  
)

export default component.exports